import axios from 'axios';

// Create axios instance with default configuration
const httpClient = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_BASEURL || 'https://motos-desa.b4code.com/',
    timeout: 30000, // 30 seconds timeout
    headers: {
        'Content-Type': 'application/json',
    },
    validateStatus: function (status) {
        // Accept all status codes, we'll handle them in the response interceptor
        return true;
    }
});

// Request interceptor to add token to all requests
httpClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle errors without throwing
httpClient.interceptors.response.use(
    (response) => {
        // Return successful responses as-is
        return response;
    },
    (error) => {
        // Don't throw errors, return the error response instead
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            return Promise.resolve(error.response);
        } else if (error.request) {
            // The request was made but no response was received
            return Promise.resolve({
                status: 0,
                data: { message: 'No response received from server' },
                error: error.request
            });
        } else {
            // Something happened in setting up the request that triggered an Error
            return Promise.resolve({
                status: 0,
                data: { message: error.message },
                error: error
            });
        }
    }
);

export default httpClient; 